import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { fromEvent, merge, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class IdleMonitorService implements OnDestroy {

    private readonly IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

    private lastActivityTimestamp: number;
    private activitySubscription: Subscription | null = null;

    constructor(private ngZone: NgZone) {
        this.lastActivityTimestamp = Date.now();
        this.initActivityListeners();
    }

    public isUserIdle(): boolean {
        const currentTime = Date.now();
        return (currentTime - this.lastActivityTimestamp) > this.IDLE_TIMEOUT_MS;
    }

    public resetActivityTimestamp(): void {
        this.lastActivityTimestamp = Date.now();
    }

    private initActivityListeners(): void {
        this.ngZone.runOutsideAngular(() => {
            const userActivityEvents$ = merge(
                fromEvent(document, 'mousemove'),
                fromEvent(document, 'keydown'),
                fromEvent(document, 'click'),
                fromEvent(document, 'wheel'),
                fromEvent(document, 'touchstart')
            );

            this.activitySubscription = userActivityEvents$
                .pipe(
                    throttleTime(1000)
                )
                .subscribe(() => {
                    this.lastActivityTimestamp = Date.now();
                });
        });
    }

    ngOnDestroy(): void {
        if (this.activitySubscription) {
            this.activitySubscription.unsubscribe();
        }
    }
}
